export default "__VITE_ASSET__c0f5f55e__"